import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { Provider } from "react-redux";
import { MandalaClient } from "./stubs/mandala_rpc/proto/mandala_grpc_web_pb";

const { REACT_APP_ENDPOINT_URL } = process.env;

const mandalaClient = new MandalaClient(
  REACT_APP_ENDPOINT_URL || "http://localhost:4000"
);
export const ClientContext = React.createContext(mandalaClient);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ClientContext.Provider value={mandalaClient}>
        <App />
      </ClientContext.Provider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
